<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <fai icon="user"/>&nbsp;Editar Cuenta Bancaria
        </div>
      </div>
      <div class="card-body pb-5">
        <hr class="mt-4"/>
        <!--begin: Bank Data -->
          <div class="row mt-4">
            <div class="col-sm col-md col-lg">
              <h4 class="m--font-info">Datos Bancarios</h4>
            </div>
          </div>
          <sys-form :inputs.sync="investor_bank_account"/>
        <!--end: Bank Data -->
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-secondary" @click="$router.push({ name: 'investors' })">
          <fai icon="reply"/> Cancelar
        </button>
        <button class="btn btn-success" :class="{ 'disabled': form.isSaving }" @click="saveForm">
          <fai :icon="['far','edit']"/> Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import banksService from '@/services/banks'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'

export default {
  name: 'InvestorBankDataUpdate',

  components: { SysForm },

  mixins: [ formMixin ],

  data () {
    return {
      investor_bank_account: {
        clave_id: {
          name: 'Clave Dispersión',
          hint: 'Id para Pagos',
          value: '',
          size: 4,
          type: 'text'
        },
        holder: {
          name: 'Cuentahabiente',
          hint: 'Cuentahabiente',
          value: '',
          type: 'text',
          size: 4,
          validate: 'required'
        },
        bank_id: {
          name: 'Banco',
          hint: 'Seleccione un banco',
          value: null,
          type: 'select',
          size: 4,
          validate: 'required',
          options: []
        },
        account: {
          name: 'Número de cuenta',
          hint: 'Número de cuenta',
          value: '',
          type: 'number',
          size: 6,
          validate: 'isBankAccount'
        },
        clabe: {
          name: 'CLABE',
          hint: 'CLABE',
          value: '',
          type: 'number',
          size: 6
        }
      }
    }
  },

  created: function () {
    this.loaded = false
    banksService.getBankData(this.$route.params.investor_id, this.$route.params.bank_id).then(res => {
      this.bank_data = res.data

      Object.keys(this.investor_bank_account).forEach(key => {
        this.investor_bank_account[key].value = this.bank_data[key]
      })

      banksService.list().then(res => {
        this.investor_bank_account.bank_id.options = res.map(bank => {
          if (this.bank_data['bank_id'] == bank.id) {
            this.investor_bank_account.bank_id.value = { value: bank.id, text: bank.name }
          }
          return { value: bank.id, text: bank.name }
        })
      })
    })
  },

  methods: {
    saveForm: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.investor_bank_account.account.value || this.investor_bank_account.clabe.value) {
            let body = {
              bank_data: this.processForm(this.investor_bank_account)
            }
            let investorId = this.$route.params.investor_id
            let bankId = this.$route.params.bank_id

            let service = banksService.putBankData(investorId, bankId, body)

            this.sendForm(service).then(res => {
              this.$router.push({ name: 'investor', params: { id: investorId } })
            }).catch(err => {
              console.log(JSON.stringify(err.statusText))
            })
          } else {
            alert('Es necesaria la cuenta o clabe bancaria')
          }
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/investors/bank-data/BankDataUpdate.vue